/* eslint-disable */

/**
 * One business partner and its sites. A supplier holds exactly one partner
 * today (`maxItems: 1`); lifting that bound is the whole multi-partner path.
 * `null` is a cleared or unlinked link (`_meta.unlinked` tells which).
 */
export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: ['array', 'null'],
      maxItems: 1,
      items: {
        type: 'object',
        additionalProperties: false,
        required: ['businessPartnerId', 'siteIds'],
        properties: {
          businessPartnerId: {type: 'string', pattern: '^\\d{3}-\\d{6}-000$'},
          siteIds: {
            type: 'array',
            minItems: 1,
            uniqueItems: true,
            items: {type: 'string', pattern: '^\\d{3}-\\d{6}-\\d{3}$'},
          },
        },
      },
    },
  },
  required: ['value'],
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    amfori_site_ids: valueSchema,
  },
}
